import P from "components/P";
import VendingProductLayout from "./VendingProductLayout";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import QuillViewer from "components/inputs/richEditor/QuillViewer";

import { decode } from "shared/utils/Utils";
import Container from "layouts/container/Container";
import style from "./VendingProductDetail.module.css";
import videoFile from "resources/video/test3.mp4";

function VendingProductDetail(props) {
    const { data, currentTab, setCurrentTab } = props;
    return (

        <VerticalFlex height={"800px"}>
            <FlexChild>
                <div className={style.quillViewerContainer}>
                    {
                        data.productDetailImg
                            ?
                            data.productDetailImg.startsWith("PHA")
                                ?
                                <Container maxWidth={1200} height={"100%"}>
                                    <QuillViewer value={decode(data.productDetailImg)} />
                                </Container>
                                :
                                <img src={data.productDetailImg} width={"100%"} />
                            :
                            <Container maxWidth={1200} height={"100%"}>
                                {/* <QuillViewer value={decode(data.productDetailImg)} /> */}
                                <video  muted autoPlay loop style={{ width: "100%", objectFit: "cover" }}>
                                    <source src={videoFile} type="video/mp4" />
                                </video>
                            </Container>
                    }
                </div>
            </FlexChild>
        </VerticalFlex>

    );
}


export default VendingProductDetail;